<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="!user?.id">
      {{ 'USERS.CREATE_USER' | translate }}
    </h2>

    <h2 class="field-dialog__header__title" *ngIf="user?.id">
      {{ (isViewMode ? 'USERS.VIEW_USER' : 'USERS.EDIT_USER') | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="field-dialog__content">
    <mat-tab label="{{ 'USERS.DIALOG.GENERAL' | translate }}">
      <disclaimer *ngIf="isViewMode" [message]="'USERS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>

      <tab-general
        [userForm]="userForm"
        [user]="user"
        [reloadPage]="reloadPage"
        [currentUser]="currentUser"
        [isViewMode]="isViewMode"
      ></tab-general>
    </mat-tab>

    <mat-tab class="groups-tab">
      <ng-template mat-tab-label>
        <span>{{ 'USERS.DIALOG.GROUPS' | translate }}</span>
        <mat-icon *ngIf="user?.id && selectedTabIndex !== 1 && !hasLinkedGroups" class="groups-tab__warning-badge"
          >error</mat-icon
        >
      </ng-template>

      <disclaimer *ngIf="isViewMode" [message]="'USERS.PERMISSIONS.NO_EDIT' | translate"></disclaimer>
      <div *ngIf="!hasLinkedGroups" class="groups-tab__group-required-warning">
        <mat-icon class="groups-tab__warning-icon">warning</mat-icon>
        <span class="groups-tab__warning-text">{{ 'USERS.DIALOG.REQUIRED_GROUP_WARNING' | translate }}</span>
      </div>
      <tab-groups [isViewMode]="isViewMode" [linkedGroups]="userForm.get('groups')"></tab-groups>
    </mat-tab>

    <mat-tab label="{{ 'USERS.DIALOG.PREFERENCES.TITLE' | translate }}">
      <disclaimer *ngIf="isViewMode" [message]="'USERS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>

      <tab-preferences [preferencesForm]="userForm.get('preferences')"></tab-preferences>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!isViewMode" class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      class="field-background"
      mat-raised-button
      *ngIf="!user.id && !hasLinkedGroups && selectedTabIndex === 0"
      [disabled]="userForm?.invalid"
      (click)="continue()"
    >
      {{ 'USERS.DIALOG.CONTINUE' | translate }}
    </button>

    <button
      class="field-background"
      mat-raised-button
      *ngIf="user.id || hasLinkedGroups || selectedTabIndex !== 0"
      (click)="saveUser()"
      [disabled]="isLoading || userForm.invalid || currentUser?.type === 'requester' || !hasLinkedGroups"
    >
      {{ 'USERS.DIALOG.SAVE' | translate }}
    </button>

    <div *ngIf="user?.id && user?.id !== currentUser?.id">
      <button
        mat-icon-button
        class="archive-icon"
        (click)="openArchiveOrUnarchiveUserDialog(true)"
        *ngIf="!user.archived"
        [disabled]="isLoading || currentUser?.type === 'requester'"
        [matTooltip]="'USERS.DIALOG.ARCHIVE' | translate"
      >
        <mat-icon>archive</mat-icon>
      </button>

      <button
        mat-icon-button
        class="unarchive-icon"
        (click)="openArchiveOrUnarchiveUserDialog(false)"
        *ngIf="user.archived"
        [disabled]="isLoading || currentUser?.type === 'requester'"
        [matTooltip]="'USERS.DIALOG.UNARCHIVE' | translate"
      >
        <mat-icon>unarchive</mat-icon>
      </button>
    </div>
  </div>
</div>
